import PropTypes from 'prop-types';
import React, { Component } from 'react';

import FormControl from 'react-bootstrap/lib/FormControl';
import HelpBlock from 'react-bootstrap/lib/HelpBlock';

class AccountTypeInput extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    styles: PropTypes.object,
    accountTypeError: PropTypes.array,
    defaultAccountType: PropTypes.string,
  };

  constructor(props) {
    super(props);
  }

  render() {
    const { onChange, styles, accountTypeError, defaultAccountType } =
      this.props;

    return (
      <div>
        <FormControl
          name="user-type"
          componentClass="select"
          onChange={(event) => onChange(event)}
          className={styles.formField}
          defaultValue={defaultAccountType ? defaultAccountType : 'select'}
        >
          <option name="user-type" disabled value="select">
            Select account type
          </option>
          <option name="user-type" value="seller">
            Looking for work (freelancer)
          </option>
          <option name="user-type" value="buyer">
            Hiring for a project (client)
          </option>
          {/* <option name="user-type" value="collector">
            Work as an AI Collector
          </option> */}
        </FormControl>
        {accountTypeError && accountTypeError.length > 0 && (
          <HelpBlock className={styles.helpBlock}>{accountTypeError}</HelpBlock>
        )}
      </div>
    );
  }
}

export default AccountTypeInput;
